import { MoodMeterGroupOrderKey } from './constants'

export const LOAD_GROUP_PLOTS_PAGE = 'LOAD_GROUP_PLOTS_PAGE'
export const RELOAD_GROUP_PLOTS_AFTER_DELETE = 'RELOAD_GROUP_PLOTS_AFTER_DELETE'
export const CHANGE_GROUP_PLOTS_PAGE = 'CHANGE_GROUP_PLOTS_PAGE'
export const CHANGE_GROUP_PLOTS_NAME_FILTER = 'CHANGE_GROUP_PLOTS_NAME_FILTER'
export const CHANGE_GROUP_PLOTS_ORDER_FILTER = 'CHANGE_GROUP_PLOTS_ORDER_FILTER'

export function loadGroupPlotsPage() {
  return {
    type: LOAD_GROUP_PLOTS_PAGE,
  }
}

export function reloadGroupPlotsAfterDelete() {
  return {
    type: RELOAD_GROUP_PLOTS_AFTER_DELETE,
  }
}

export function changeGroupPlotsPage(page: number) {
  return {
    type: CHANGE_GROUP_PLOTS_PAGE,
    payload: page,
  }
}

export function changeGroupPlotsNameFilter(name: string) {
  return {
    type: CHANGE_GROUP_PLOTS_NAME_FILTER,
    payload: name,
  }
}

export function changeGroupPlotsOrderFilter(order: MoodMeterGroupOrderKey) {
  return {
    type: CHANGE_GROUP_PLOTS_ORDER_FILTER,
    payload: order,
  }
}
